import React from "react";
import Button from "@mui/material/Button";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";

export default function ({ sx, icon }) {
  return (
    <Button
      variant="contained"
      sx={{
        minWidth: 56,
        minHeight: 56,
        padding: 0,
        borderRadius: "50%",
        opacity: 0.75,
        backgroundColor: "#FFF",
        color: "text.primary",
        "&:hover": {
          backgroundColor: "#FFF",
          color: "text.primary",
          opacity: 1,
        },
        ...sx,
      }}
    >
      {icon ? (
        icon
      ) : (
        <PlayArrowRoundedIcon sx={{ minWidth: 50, minHeight: 38 }} />
      )}
    </Button>
  );
}
